var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 6h7m-7 6h7m-7 6h9m2-9l3-3l3 3m-3-3v12"
    }, null, -1)
  ]));
}
__name(render, "render");
const sortAscending = markRaw({ name: "tabler-sort-ascending", render });
export {
  sortAscending as default
};
//# sourceMappingURL=sort-ascending.js.map
